<div class="hds-list-item margin-v-xs bg-transparent bg-hover cursor-hover">
  <a [href]="articleUrl"
     target="_blank"
     class="d-block"
     (click)="onClickTrackAction()">
    <div class="grid-x">
      <div class="cell shrink">
        <div *ngIf="article.thumbnailUrl"
             class="actu-image-event"
             [style.background-image]="'url(' + article.thumbnailUrl + ')'">
        </div>
      </div>
      <div class="cell auto">
        <div class="d-block padding-l-s">
          <span class="i-block margin-b-xs f-7 font-bold c-black overflow-ellipsis">
            {{article.title}}
          </span>
          <br/>
          {{article.lastPublicationDate | date:'dd/MM/yyyy'}} - {{article.author}}
        </div>
      </div>
    </div>
  </a>
</div>
